import {
  IAuthorizationInitialState,
  IUserProfile,
} from "../Interfaces/IInitialState";
import { AuthorizationProfileBMDStatus } from "us.common/constants";

const profile: IUserProfile = {
  accessAuthorityLevel: 0,
  accessAuthorityComment: "",
  isCommentEnable: false,
  featureList: [],
  userEmail:"",
  isUniQAutoOpenEnabled: AuthorizationProfileBMDStatus.NO,
};

export const initialState: IAuthorizationInitialState = {
  authorizationProfile: profile,
};
